import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import type { Channel } from '../../utils/get-channels-from-pypes';
import { LONG_NAME_STYLE } from '../../utils/long-name-style';

/**
 * The Channels table's Name cell. The name is bounded (see `LONG_NAME_STYLE`)
 * so a long one cannot push the other columns behind a horizontal scroll; the
 * full text stays in the DOM and in `title`.
 */
export const renderChannelNameCell = (channel: Channel) =>
  html`<ps-text-subtitle
    size="small"
    test-id=${`ps-channel-name-${channel.id}`}
  >
    <span
      data-long-name
      title=${channel.name}
      style=${styleMap(LONG_NAME_STYLE)}
      >${channel.name}</span
    >
  </ps-text-subtitle>`;
